/*
 * BestyBuys - button words for the product page buy buttons (Add to cart + Buy it now).
 * Only loaded when a button text, a "Buy it now" icon or the "added" message is set in the Theme Editor
 * (Product page > Buy buttons). Every word, the price format and the timing come from data attributes on
 * .bb-btns (written by snippets/buy-buttons.liquid), so nothing is fixed here.
 *
 * It keeps the words in place when the theme redraws the buttons (variant change, sold out, Shopify's
 * "Buy it now" loading late) and shows a short "added" message after a successful Add to cart.
 */
(function () {
  'use strict';
  if (window.bbBuyExtras) return;

  function group(n, sep) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  /* Money in the store's own format, without a trailing ".00" (same rules as assets/bb-offers.js) */
  function money(cents, format) {
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    var type = match ? match[1] : 'amount';
    var decimals = type.indexOf('no_decimals') > -1 ? 0 : 2;
    var thousands = ',';
    var point = '.';
    if (type.indexOf('comma_separator') > -1) {
      thousands = '.';
      point = ',';
    } else if (type.indexOf('apostrophe_separator') > -1) {
      thousands = "'";
    } else if (type.indexOf('space_separator') > -1) {
      thousands = ' ';
    }
    var value = (Math.round(cents) / 100).toFixed(decimals).split('.');
    var text = group(value[0], thousands) + (value[1] && value[1] !== '00' ? point + value[1] : '');
    return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, text);
  }

  function fill(template, wrap) {
    var cents = parseFloat(wrap.getAttribute('data-bb-price'));
    var price = isNaN(cents) ? '' : money(cents, wrap.getAttribute('data-bb-money'));
    return String(template).replace(/\{price\}/g, price).replace(/\s+/g, ' ').trim();
  }

  function textNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim() !== '') return n;
    }
    return null;
  }

  function applyAddToCart(wrap) {
    var btn = wrap.querySelector('.product-form__submit');
    if (!btn || btn.hidden) return;
    var span = btn.querySelector(':scope > span');
    if (!span) return;
    var want = null;
    var added = wrap.hasAttribute('data-bb-added') ? wrap.getAttribute('data-bb-success') : '';
    var template = wrap.getAttribute('data-bb-atc');
    var soldOut = wrap.getAttribute('data-bb-soldout');
    if (added) {
      want = added;
    } else if (btn.disabled) {
      if (soldOut) want = soldOut;
    } else if (template) {
      want = fill(template, wrap);
    }
    if (want !== null && span.textContent.trim() !== want) span.textContent = want;
  }

  function applyBuyNow(wrap) {
    var btn = wrap.querySelector('.shopify-payment-button__button--unbranded');
    if (!btn) return;
    var template = wrap.getAttribute('data-bb-bn');
    if (template) {
      var want = fill(template, wrap);
      var node = textNode(btn);
      if (!node) btn.appendChild(document.createTextNode(want));
      else if (node.nodeValue.trim() !== want) node.nodeValue = want;
    }
    var tplId = wrap.getAttribute('data-bb-bn-icon');
    if (tplId && !btn.querySelector('.bb-ico')) {
      var tpl = document.getElementById(tplId);
      var icon = tpl && tpl.content && tpl.content.firstElementChild;
      if (icon) {
        var copy = icon.cloneNode(true);
        if (wrap.getAttribute('data-bb-icon-side') === 'right') btn.appendChild(copy);
        else btn.insertBefore(copy, btn.firstChild);
      }
    }
    var payId = wrap.getAttribute('data-bb-bn-pay');
    if (payId && !btn.querySelector('.bb-bnpay')) {
      var payTpl = document.getElementById(payId);
      var pay = payTpl && payTpl.content && payTpl.content.firstElementChild;
      if (pay) btn.appendChild(pay.cloneNode(true));
    }
  }

  function apply(wrap) {
    applyAddToCart(wrap);
    applyBuyNow(wrap);
  }

  function watch(wrap) {
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply(wrap);
      });
    });
    observer.observe(wrap, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }

  function flash(wrap) {
    if (!wrap.getAttribute('data-bb-success')) return;
    var secs = parseFloat(wrap.getAttribute('data-bb-secs')) || 2;
    wrap.setAttribute('data-bb-added', '');
    wrap.classList.add('bb-added');
    applyAddToCart(wrap);
    clearTimeout(wrap.bbAddedTimer);
    wrap.bbAddedTimer = setTimeout(function () {
      wrap.removeAttribute('data-bb-added');
      wrap.classList.remove('bb-added');
      applyAddToCart(wrap);
    }, secs * 1000);
  }

  function all() {
    return document.querySelectorAll('.bb-btns[data-bb-x]');
  }

  function init() {
    all().forEach(function (wrap) {
      if (wrap.bbReady) return;
      wrap.bbReady = true;
      apply(wrap);
      watch(wrap);
    });
  }

  window.bbBuyExtras = { money: money, fill: fill, init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    /* A new variant has a new price: update it first, then redraw the words */
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      all().forEach(function (wrap) {
        if (variant && variant.price !== undefined) wrap.setAttribute('data-bb-price', variant.price);
        setTimeout(function () {
          apply(wrap);
        }, 60);
      });
    });
    /* Add to cart worked: show the short "added" message */
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      all().forEach(flash);
    });
  }
})();
